import React, { useEffect, useRef, useState } from "react";
import Select, { components } from "react-select";
import closeIcon from "../../../assets/forhomepage/close_icon.svg";
import searchIcon from "../../../assets/forhomepage/search_icon.svg";
import "./CustomSelect.scss";
import Highlighter from "react-highlight-words";
const { MenuList, ValueContainer, SingleValue, Placeholder } = components;

const CustomMenuList = ({ selectProps, ...props }) => {
  const {
    onInputChange,
    inputValue,
    onMenuInputFocus,
    showSearch,
    fixedBottomBtn,
    fixedBtbOnChange,
    seacrhbarPlaceholder,
  } = selectProps;

  // Copied from source
  const ariaAttributes = {
    "aria-autocomplete": "list",
    "aria-label": selectProps["aria-label"],
    "aria-labelledby": selectProps["aria-labelledby"],
  };

  return (
    <div
      style={{
        width: "100%",
      }}
    >
      {showSearch ? (
        <div
          style={{
            padding: 10,
            boxSizing: "border-box",
            border: "none",
            borderBottom: "1px solid lightgrey",
          }}
        >
          <div class="search_container">
            <div className="custom_search_icon">
              <img src={searchIcon} alt="searchIcon" />
            </div>
            <div style={{ display: "flex", width: "100%" }}>
              <input
                type="text"
                class="inputSearch"
                placeholder={
                  seacrhbarPlaceholder
                    ? seacrhbarPlaceholder
                    : "Search for Procedure"
                }
                value={inputValue}
                onChange={(e) =>
                  onInputChange(e.currentTarget.value, {
                    action: "input-change",
                  })
                }
                onMouseDown={(e) => {
                  e.stopPropagation();
                  e.target.focus();
                }}
                onTouchEnd={(e) => {
                  e.stopPropagation();
                  e.target.focus();
                }}
                onFocus={onMenuInputFocus}
                {...ariaAttributes}
              />
              {inputValue.length ? (
                <img
                  className="close_search_icon"
                  src={closeIcon}
                  alt="close"
                  onClick={() => {
                    onInputChange("", {
                      action: "input-change",
                    });
                  }}
                />
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
      <MenuList {...props} selectProps={selectProps} />
      {fixedBottomBtn && (
        <button
          // key={index}
          className={"fixed_btn"}
          onClick={fixedBtbOnChange}
          onTouchEnd={fixedBtbOnChange}
        >
          Add New Procedure
          {/* {addNewProcedure.label} */}
        </button>
      )}
    </div>
  );
};

// Set custom `SingleValue` and `Placeholder` to keep them when searching
const CustomValueContainer = ({ children, selectProps, ...props }) => {
  const commonProps = {
    cx: props.cx,
    clearValue: props.clearValue,
    getStyles: props.getStyles,
    getValue: props.getValue,
    hasValue: props.hasValue,
    isMulti: props.isMulti,
    isRtl: props.isRtl,
    options: props.options,
    selectOption: props.selectOption,
    setValue: props.setValue,
    selectProps,
    theme: props.theme,
  };

  return (
    <ValueContainer {...props} selectProps={selectProps}>
      {React.Children.map(children, (child) => {
        return child ? (
          child
        ) : props.hasValue ? (
          <SingleValue
            {...commonProps}
            isFocused={selectProps.isFocused}
            isDisabled={selectProps.isDisabled}
          >
            {selectProps.getOptionLabel(props.getValue()[0])}
          </SingleValue>
        ) : (
          <Placeholder
            {...commonProps}
            key="placeholder"
            isDisabled={selectProps.isDisabled}
            data={props.getValue()}
          >
            {selectProps.placeholder}
          </Placeholder>
        );
      })}
    </ValueContainer>
  );
};

const CustomSelect = ({
  options,
  placeholder,
  value,
  handleChange,
  handleBlur,
  customStyles,
  className,
  showSearch,
  isSearchable,
  noOptionsMessage,
  fixedBottomBtn,
  fixedBtbOnChange,
  seacrhbarPlaceholder,
  ...props
}) => {
  const containerRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const styles = {
    control: (base) => ({
      ...base,
      width: "100%",
      background: " #F5F6F7 0% 0% no-repeat padding-box",
      boxShadow: "none",
      border: "none",
      cursor: "pointer",
      height: "20px",
      "&:hover": {
        boxShadow: "none",
      },
    }),
    menuList: (provided) => ({
      ...provided,
      cursor: "pointer",
      maxHeight: "200px",
      paddingTop: "0px",
      "&::-webkit-scrollbar": {
        width: "16px",
        height: " 16px",
        display: "block !important",
        background: "none",
      },
      "&::-webkit-scrollbar-track": {
        background: "none",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb": {
        boxShadow: "inset 0 0 16px rgba(240, 232, 232, 1)",
        minHeight: "60px !important",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#888",
      },
    }),
  };

  const onDomClick = (e) => {
    let menu = containerRef.current.querySelector(".react-select__menu");

    if (
      !containerRef.current.contains(e.target) ||
      !menu ||
      !menu.contains(e.target)
    ) {
      setIsFocused(false);
      // setInputValue("");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", onDomClick);

    return () => {
      document.removeEventListener("mousedown", onDomClick);
    };
  }, []);

  const filterOption = (dropdownOptions, inputValue) => {
    if (
      dropdownOptions.label
        ?.replace("  ", " ")
        .toLowerCase()
        .includes(inputValue?.replace("  ", " ").toLowerCase())
    ) {
      return true;
    } else {
      return false;
    }
  };

  function formatOptionLabel({ label }, { inputValue }) {
    return (
      <Highlighter
        highlightClassName="font-weight-bold highlight_background"
        searchWords={[inputValue?.replace("  ", " ")]}
        autoEscape={true}
        textToHighlight={label?.replace("  ", " ")}
      />
    );
  }
  const DropdownIndicator = (property) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...property}>
          {property.selectProps.menuIsOpen ? (
            <i
              className="fa fa-caret-up"
              style={{
                color: props.isDisabled ? "hsl(0, 0%, 70%)" : "#17bae0",
                padding: "0px 3px",
              }}
            ></i>
          ) : (
            <i
              className="fa fa-caret-down"
              style={{
                color: props.isDisabled ? "hsl(0, 0%, 70%)" : "#17bae0",
                padding: "0px 3px",
              }}
            ></i>
          )}
        </components.DropdownIndicator>
      )
    );
  };
  return (
    <div ref={containerRef} className={"select_container"}>
      <Select
        {...props}
        className={`${className}`}
        classNamePrefix="react-select"
        styles={customStyles || styles}
        options={options}
        components={{
          MenuList: CustomMenuList,
          DropdownIndicator: DropdownIndicator,
          ValueContainer: CustomValueContainer,
        }}
        value={value}
        isSearchable={isSearchable}
        onMenuInputFocus={() => setIsFocused(true)}
        onChange={(opt) => {
          handleChange(opt);
          setIsFocused(false);
        }}
        showSearch={showSearch}
        formatOptionLabel={formatOptionLabel}
        filterOption={filterOption}
        onInputChange={(val) => setInputValue(val)}
        {...{
          menuIsOpen: isFocused || undefined,
          isFocused: isFocused || undefined,
        }}
        noOptionsMessage={() => noOptionsMessage || "No Result Found"}
        fixedBottomBtn={fixedBottomBtn}
        fixedBtbOnChange={fixedBtbOnChange}
        seacrhbarPlaceholder={seacrhbarPlaceholder}
        placeholder={placeholder}
      />
    </div>
  );
};

export default CustomSelect;
